<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    button_type: {
      type: String,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    }
  });

  const disable_button = computed(() => {
    return props.quantity == 0 && props.button_type == 'decrease';
  });
</script>
<template>
  <button type="button" :class="['btn btn-primary cart-item-buttons cart-item__quantity-box-item cart-item__quantity-box-item--' + button_type]" :disabled="disable_button">
    <i class="bi bi-plus" v-if="button_type === 'increase'"></i>
    <i class="bi bi-dash" v-if="button_type === 'decrease'"></i>
  </button>
</template>
